import i18n from '../i18n';

const MESSAGE_RULES = [
  { test: /too many|rate limit/i, key: 'rateLimit' },
  { test: /invalid credentials/i, key: 'invalidCredentials' },
  { test: /invalid or expired reset token/i, key: 'passwordResetInvalid' },
  { test: /forbidden|access denied|restricted/i, key: 'forbidden' },
  { test: /not found/i, key: 'notFound' },
  { test: /internal server|server error/i, key: 'serverError' },
  { test: /invalid email|email.*valid|isemail/i, key: 'invalidEmail' },
  { test: /password.*8/i, key: 'passwordMin' },
  { test: /name.*2.*150|name must have|name must be 2-100/i, key: 'nameLength' },
  { test: /valid date|yyyy-mm-dd|iso8601|launch date|date must use|invalid report date/i, key: 'dateFormat' },
  { test: /after start date|cannot be earlier|end date must be after|endDate must be greater/i, key: 'endBeforeStart' },
  { test: /cannot exceed|too long|at most|max/i, key: 'maxLength' },
  { test: /uuid|valid contact|valid involved|valid responsible|valid entry|valid id|valid.*uuid/i, key: 'invalidUuid' },
  { test: /amount.*greater than zero|value.*greater than zero/i, key: 'amountGreaterZero' },
  { test: /total hours.*greater/i, key: 'hoursGreaterZero' },
  { test: /hourly rate.*zero or greater/i, key: 'hourlyRateMin' },
  { test: /time.*hh:mm/i, key: 'timeFormat' },
  { test: /type.*debit.*credit/i, key: 'financialType' },
  { test: /service name.*required/i, key: 'serviceNameRequired' },
  { test: /select a contact or enter/i, key: 'involvedRequired' },
  { test: /validation failed|validation error/i, key: 'validationFailed' },
  { test: /required|notempty|must not be empty/i, key: 'required' },
];

const t = (key, options) => i18n.t(key, options);

export const translateApiField = (field) => {
  const safeField = field || 'form';
  const translated = t(`apiErrors.fields.${safeField}`);
  if (translated !== `apiErrors.fields.${safeField}`) return translated;
  return safeField;
};

export const translateApiMessage = (message, fallbackKey = 'invalidField') => {
  if (!message) return t(`apiErrors.messages.${fallbackKey}`);
  const raw = String(message);
  const rule = MESSAGE_RULES.find(({ test }) => test.test(raw));
  if (rule) return t(`apiErrors.messages.${rule.key}`);
  return raw;
};

export const getApiErrorMessage = (error, fallback) => {
  const data = error?.response?.data;
  const status = error?.response?.status;
  const isObjectData = data && typeof data === 'object';
  const details = Array.isArray(isObjectData ? data.details : null) ? data.details : [];
  const firstDetail = details[0];

  if (firstDetail?.field || firstDetail?.message) {
    const field = translateApiField(firstDetail.field || 'form');
    const message = translateApiMessage(firstDetail.message);
    return t('apiErrors.fieldMessage', { field, message });
  }

  if (typeof firstDetail === 'string') return translateApiMessage(firstDetail);

  if (status === 429) return t('apiErrors.messages.rateLimit');
  if (status === 403) return t('apiErrors.messages.forbidden');
  if (status === 404) return t('apiErrors.messages.notFound');
  if (status >= 500) return t('apiErrors.messages.serverError');

  if (isObjectData && data.error) return translateApiMessage(data.error);
  return fallback || t('apiErrors.messages.serverError');
};
